import { render, staticRenderFns } from "./V2BrandCollections.vue?vue&type=template&id=4b0dbeb9&scoped=true&"
import script from "./V2BrandCollections.vue?vue&type=script&lang=js&"
export * from "./V2BrandCollections.vue?vue&type=script&lang=js&"
import style0 from "./V2BrandCollections.vue?vue&type=style&index=0&id=4b0dbeb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0dbeb9",
  null
  
)

export default component.exports